<template>
  <div class="ar-popup">
    <div class="ar-popup-box">
      <div class="ar-popup-title ar-flex">
        <slot name="header"></slot>  
      </div>
      <div class="ar-popup-content">
        <slot name="content"></slot>  
      </div>
      <div class="ar-popup-footer">
        <slot name="footer"></slot> 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArPopup',
  componentName: 'ArPopup',
}
</script>

<style lang="scss" scoped>
.ar-popup{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
  .ar-popup-box{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 450px;
    height: auto;
    background-color: #fff;
    border-radius: 10px;
    .ar-popup-title{
      height: 56px;
      padding: 0 20px;
      border-bottom: 1px solid #ddd;
      box-sizing: border-box;
      justify-content: space-between;
      h3{
        display: block;
        font-size:16px;
        font-weight:400;
        color:rgba(96,96,96,1);
        line-height:56px;
      }
      i{
        cursor: pointer;
        margin: 13px 0; 
        vertical-align: middle;
        display: inline-block;  
        background: url('../../../../anystatic/img/close-default.png') no-repeat center center;
        width: 30px;
        height: 30px;
        &:hover{
          background: url('../../../../anystatic/img/close-hover.png') no-repeat center center;
        }
        &:active{
          background: url('../../../../anystatic/img/close-active.png') no-repeat center center;
        }
      }
    }
    .ar-popup-content{
      padding: 20px 20px 10px;
      box-sizing: border-box;
      >span{
        display: inline-block;
        font-size:14px;
        color:rgba(96,96,96,1);
        line-height:28px;
        margin-bottom: 5px;
      }
    }
    .ar-popup-footer{
      padding: 10px 20px 20px;
      text-align: center;
      .ar-button{
        margin: 0 5px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/anyUI/popup/popup.vue